import { render, staticRenderFns } from "./inquiries.vue?vue&type=template&id=79c102d4&scoped=true&"
import script from "./inquiries.vue?vue&type=script&lang=js&"
export * from "./inquiries.vue?vue&type=script&lang=js&"
import style0 from "./inquiries.vue?vue&type=style&index=0&id=79c102d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c102d4",
  null
  
)

export default component.exports